import { getCkeditor } from "src/hidden-ckeditor";

export function normalizeWithCKEditor(rawHtml: string | null | undefined) {
  const editor = getCkeditor();

  editor.setData(rawHtml ?? "");
  return editor.getData();
}
